import React, { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import Modal from "./Modal";
import CopyRight from "./CopyRights";
import LoadingScreen from "./LoadingScreen";
import "./Projects.css";

const UIUX = () => {
  const [uiuxProjects, setUIUXProjects] = useState([]);
  const [modalData, setModalData] = useState({}); // this use to get one drawing data to popup
  const [isModalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // Track the loading state
  const [dataLoaded, setDataLoaded] = useState(false); // To control animation finish

  const openModal = (projectData) => {
    setModalData(projectData);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  useEffect(() => {
    const getUIUX = async () => {
      try {
        // await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate delay of 3 seconds
        await axios
          .get("/api/project/getUIUXProjects/")
          .then((res) => {
            setUIUXProjects(res.data.prj);
            console.log(res.data.message);
          })
          .catch((error) => {
            console.log("☠️ Error Detected : ", error.messasge);
          });
      } catch (error) {
        console.log("☠️ Error Detected : ", error.messasge);
      } finally {
        setIsLoading(false); // Stop the loading animation
        setDataLoaded(true); // Trigger the final 100% fill
      }
    };

    getUIUX();
  }, []);

  if (isLoading) {
    return <LoadingScreen isLoading={isLoading} dataLoaded={dataLoaded} />; // Show the loading animation while fetching data and Pass loading state to animation component
  }

  return (
    <div className="project-div">
      <div className="home-title">
        <div className="head-title">UI/UX Designs</div>
      </div>

      <div className="home-info-div">
        Explore my UI/UX design portfolio, featuring work for mobile, web, and
        tablet platforms. My designs focus on creating intuitive, user-friendly
        interfaces that offer seamless experiences across devices. From
        wireframes to fully polished prototypes, I strive to blend functionality
        with aesthetic appeal, ensuring each project is not only visually
        engaging but also efficient and accessible for all users.
      </div>

      <div className="projects-cards">
        {uiuxProjects.map((projectData) => (
          <div className="project-card" key={projectData._id}>
            <div className="project-image-div">
              <img
                src={projectData.imgUrl}
                alt="project-image"
                className="project-image"
                onClick={() => openModal(projectData)}
                data-bs-toggle="modal"
                data-bs-target="#projectModal"
              />
            </div>
            <div className="project-details-div">
              <div className="tooltip-text-project">
                {projectData.projectTopic}
              </div>
              <div
                className="project-title"
                onClick={() => openModal(projectData)}
                data-bs-toggle="modal"
                data-bs-target="#projectModal"
              >
                {projectData.projectTopic}
              </div>
              <div className="project-created-date">
                {moment(projectData.createdAt).format("MMMM Do YYYY | h:mm a")}
              </div>
              <div className="project-created-date">
                {moment(projectData.createdAt, "YYYYMMDD").fromNow()}
              </div>
            </div>
          </div>
        ))}
      </div>

      <Modal isOpen={isModalOpen} onClose={closeModal} modalData={modalData} />

      <CopyRight />
    </div>
  );
};

export default UIUX;
